export const services = [
  {
    name: 'Walk-In Showers',
    slug: 'walk-in-showers',
    iconName: 'ShowerHeadIcon',
    description:
      'Upgrade your bathroom with a safe, accessible, and stylish walk-in shower.',
    costRange: { low: 2500, high: 8000, average: 5000 },
    benefits: [
      'Improved safety and accessibility',
      'Modern, sleek design',
      'Easier to clean',
      'Increases home value',
      'Customizable features',
    ],
    faqs: [
      {
        question: 'How long does installation take?',
        answer:
          'Most walk-in showers can be installed in 1-2 days by professionals.',
      },
      {
        question: 'Are walk-in showers covered by Medicare?',
        answer:
          'In some cases, if deemed medically necessary, Medicare may cover a portion of the cost.',
      },
      {
        question: 'Do they add value to a home?',
        answer:
          'Yes, modern, accessible bathrooms are highly sought after by buyers.',
      },
      {
        question: 'Can I convert my existing tub?',
        answer:
          'Absolutely. Tub-to-shower conversions are one of our most popular services.',
      },
    ],
  },
  {
    name: 'Walk-In Tubs',
    slug: 'walk-in-tubs',
    iconName: 'BathIcon',
    description:
      'Enjoy a relaxing, therapeutic bath without the worry of slipping or falling.',
    costRange: { low: 3000, high: 10000, average: 6000 },
    benefits: [
      'Low step-in threshold',
      'Hydrotherapy options',
      'Built-in seating',
      'Anti-slip flooring',
      'Maintains independence',
    ],
    faqs: [
      {
        question: 'How long does it take to fill and drain?',
        answer:
          'Modern walk-in tubs feature fast-fill and quick-drain technology, usually taking 2-3 minutes.',
      },
      {
        question: 'Will it fit in my current bathroom?',
        answer:
          'Yes, walk-in tubs are designed to fit into standard bathtub alcoves.',
      },
      {
        question: 'What is hydrotherapy?',
        answer:
          'Hydrotherapy uses water jets to massage muscles, providing relief for arthritis and joint pain.',
      },
      {
        question: 'Are they difficult to clean?',
        answer:
          'No, most feature gel-coat surfaces that resist mold and mildew.',
      },
    ],
  },
  {
    name: 'Stairlifts',
    slug: 'stairlifts',
    iconName: 'ArrowUpIcon',
    description:
      'Regain full access to your multi-level home with a safe and reliable stairlift.',
    costRange: { low: 2000, high: 6000, average: 3500 },
    benefits: [
      'Safe navigation between floors',
      'Battery backup during power outages',
      'Folds away when not in use',
      'Custom fit for straight or curved stairs',
      'Quick installation',
    ],
    faqs: [
      {
        question: 'Can a stairlift be installed on curved stairs?',
        answer:
          'Yes, custom curved stairlifts are designed to fit the exact specifications of your staircase.',
      },
      {
        question: 'Will it damage my walls?',
        answer:
          'No, stairlifts are mounted directly to the stair treads, not the walls.',
      },
      {
        question: 'What happens if the power goes out?',
        answer:
          'Most units have a battery backup that allows for several trips during a power outage.',
      },
      {
        question: 'Are they noisy?',
        answer:
          'Modern stairlifts operate very quietly, causing minimal disturbance.',
      },
    ],
  },
  {
    name: 'Window Replacement',
    slug: 'window-replacement',
    iconName: 'SquareIcon',
    description:
      "Enhance your home's curb appeal and energy efficiency with new replacement windows.",
    costRange: { low: 400, high: 1500, average: 800 },
    benefits: [
      'Lower energy bills',
      'Improved home security',
      'Noise reduction',
      'Increased property value',
      'Easier maintenance',
    ],
    faqs: [
      {
        question: 'How do I know if I need new windows?',
        answer:
          'Drafts, condensation between panes, difficulty opening/closing, and high energy bills are common signs.',
      },
      {
        question: 'What are the best window materials?',
        answer:
          'Vinyl is popular for affordability and low maintenance, while wood offers a classic look and excellent insulation.',
      },
      {
        question: 'How long does installation take?',
        answer:
          'A professional crew can typically replace 10-15 windows in a single day.',
      },
      {
        question: 'Do new windows really save energy?',
        answer:
          'Yes, energy-efficient windows can reduce heating and cooling costs by up to 15%.',
      },
    ],
  },
  {
    name: 'Gutter Guards',
    slug: 'gutter-guards',
    iconName: 'LayersIcon',
    description:
      'Protect your home from water damage and never clean your gutters again.',
    costRange: { low: 900, high: 3000, average: 1500 },
    benefits: [
      'Prevents clogs and overflows',
      'Reduces maintenance',
      'Protects foundation and roof',
      'Deters pests and rodents',
      'Extends gutter lifespan',
    ],
    faqs: [
      {
        question: 'Do gutter guards work in heavy rain?',
        answer:
          'High-quality guards are designed to handle heavy downpours while keeping debris out.',
      },
      {
        question: 'Will they fit my existing gutters?',
        answer:
          'Most gutter guard systems can be installed over your existing gutters.',
      },
      {
        question: 'Do I still need to clean them?',
        answer:
          'They significantly reduce cleaning, but an occasional brush-off of the top surface may be needed.',
      },
      {
        question: 'Are they visible from the ground?',
        answer:
          'Most modern systems have a low profile and are barely noticeable from the ground.',
      },
    ],
  },
  {
    name: 'Roofing',
    slug: 'roofing',
    iconName: 'HomeIcon',
    description: 'Secure your home with a durable, weather-resistant new roof.',
    costRange: { low: 5000, high: 15000, average: 9000 },
    benefits: [
      'Protects against weather damage',
      'Improves energy efficiency',
      'Enhances curb appeal',
      'Increases home value',
      'Peace of mind with warranties',
    ],
    faqs: [
      {
        question: 'How long does a new roof last?',
        answer:
          'Asphalt shingles typically last 20-30 years, while metal or tile roofs can last 50+ years.',
      },
      {
        question: 'Can you roof over existing shingles?',
        answer:
          'Sometimes, but a full tear-off is usually recommended to inspect the decking for damage.',
      },
      {
        question: 'How long does a roof replacement take?',
        answer:
          'Most residential roof replacements take 1-3 days depending on the size and weather.',
      },
      {
        question: 'What are the signs I need a new roof?',
        answer:
          'Curling or missing shingles, leaks, sagging, and age (20+ years) are key indicators.',
      },
    ],
  },
  {
    name: 'Siding',
    slug: 'siding',
    iconName: 'HomeIcon',
    description:
      "Transform your home's exterior with low-maintenance, beautiful siding.",
    costRange: { low: 6000, high: 18000, average: 11000 },
    benefits: [
      'Dramatically improves curb appeal',
      'Adds insulation (if insulated siding)',
      'Low maintenance',
      'Protects against elements',
      'High return on investment',
    ],
    faqs: [
      {
        question: 'What is the most popular siding material?',
        answer:
          'Vinyl siding is the most popular due to its affordability, durability, and low maintenance.',
      },
      {
        question: 'Does new siding help with insulation?',
        answer:
          'Yes, especially if you choose insulated siding or add house wrap during installation.',
      },
      {
        question: 'How often does siding need to be painted?',
        answer:
          'Vinyl and fiber cement siding do not require painting, unlike traditional wood siding.',
      },
      {
        question: 'How long does installation take?',
        answer:
          'A typical siding replacement takes 1-2 weeks depending on the house size.',
      },
    ],
  },
  {
    name: 'Solar Panels',
    slug: 'solar',
    iconName: 'SunIcon',
    description:
      'Generate your own clean energy and drastically reduce your electricity bills.',
    costRange: { low: 15000, high: 30000, average: 20000 },
    benefits: [
      'Significantly lower electric bills',
      'Reduces carbon footprint',
      'Increases property value',
      'Protection against rising energy costs',
      'Tax incentives and rebates available',
    ],
    faqs: [
      {
        question: 'Do solar panels work on cloudy days?',
        answer:
          'Yes, they still generate power on cloudy days, though at a reduced efficiency.',
      },
      {
        question: 'How long do solar panels last?',
        answer:
          'Most panels are guaranteed to last 25-30 years with minimal degradation.',
      },
      {
        question: 'Will I still have an electric bill?',
        answer:
          'You will likely still have a small connection fee, but your usage charges can be offset entirely.',
      },
      {
        question: 'What happens when it snows?',
        answer:
          'Snow can temporarily block production, but it usually melts quickly off the dark, angled panels.',
      },
    ],
  },
  {
    name: 'Bathroom Remodel',
    slug: 'bathroom-remodel',
    iconName: 'ShowerHeadIcon',
    description: 'Create a spa-like oasis with a complete bathroom renovation.',
    costRange: { low: 10000, high: 30000, average: 18000 },
    benefits: [
      'Modernized fixtures and design',
      'Improved functionality and layout',
      'Increased home value',
      'Better energy and water efficiency',
      'Enhanced relaxation',
    ],
    faqs: [
      {
        question: 'How long does a full remodel take?',
        answer:
          'A complete remodel typically takes 3-4 weeks from demolition to finish.',
      },
      {
        question: 'What is the most expensive part of a bathroom remodel?',
        answer:
          'Labor, plumbing changes, and high-end tile or fixtures are usually the biggest costs.',
      },
      {
        question: 'Do I need a permit?',
        answer:
          'Yes, if you are moving plumbing or electrical lines, a permit is usually required.',
      },
      {
        question: 'Can I stay in my home during the remodel?',
        answer: 'Yes, as long as you have another functioning bathroom to use.',
      },
    ],
  },
  {
    name: 'Kitchen Remodel',
    slug: 'kitchen-remodel',
    iconName: 'CookingPotIcon',
    description:
      'Revitalize the heart of your home with a stunning new kitchen design.',
    costRange: { low: 15000, high: 50000, average: 28000 },
    benefits: [
      'Improved layout and workflow',
      'Updated, energy-efficient appliances',
      'Increased storage space',
      'High return on investment',
      'Better entertaining space',
    ],
    faqs: [
      {
        question: 'How much should I budget for a kitchen remodel?',
        answer:
          "A good rule of thumb is to budget 10-15% of your home's total value.",
      },
      {
        question: 'Can I reface cabinets instead of replacing them?',
        answer:
          'Yes, refacing is a cost-effective option if the cabinet boxes are in good condition.',
      },
      {
        question: 'How long will I be without a kitchen?',
        answer:
          "A major remodel can take 4-8 weeks, during which you'll need a temporary setup.",
      },
      {
        question: 'What countertops are most durable?',
        answer:
          'Quartz and granite are highly durable, non-porous, and resist scratching and staining.',
      },
    ],
  },
  {
    name: 'Flooring',
    slug: 'flooring',
    iconName: 'FootprintsIcon',
    description:
      'Upgrade your interior with beautiful, durable new flooring options.',
    costRange: { low: 1500, high: 6000, average: 3000 },
    benefits: [
      'Instantly updates room aesthetics',
      'Easier to clean and maintain',
      'Removes allergens (vs old carpet)',
      'Increases home value',
      'Durable options for high traffic',
    ],
    faqs: [
      {
        question: 'What is the most durable flooring?',
        answer:
          'Luxury Vinyl Plank (LVP) and tile are among the most durable and water-resistant options.',
      },
      {
        question: 'Can new flooring be installed over old flooring?',
        answer:
          'Sometimes. Floating floors like LVP can often go over existing hard surfaces.',
      },
      {
        question: 'How long does installation take?',
        answer: 'Most single-room installations take 1-2 days.',
      },
      {
        question: 'Is hardwood flooring worth the cost?',
        answer:
          'Yes, hardwood offers timeless appeal and excellent resale value.',
      },
    ],
  },
  {
    name: 'HVAC',
    slug: 'hvac',
    iconName: 'ThermometerIcon',
    description:
      'Keep your home perfectly comfortable year-round with a new HVAC system.',
    costRange: { low: 5000, high: 12000, average: 7500 },
    benefits: [
      'Consistent indoor temperatures',
      'Lower energy bills',
      'Improved indoor air quality',
      'Quieter operation',
      'Fewer breakdowns and repairs',
    ],
    faqs: [
      {
        question: 'How often should I replace my HVAC system?',
        answer: 'Most systems last 15-20 years with proper maintenance.',
      },
      {
        question: 'What is a SEER rating?',
        answer:
          'SEER measures cooling efficiency. Higher SEER ratings mean better energy efficiency.',
      },
      {
        question: 'Should I replace my AC and furnace at the same time?',
        answer:
          'It is highly recommended to ensure the components are matched for maximum efficiency.',
      },
      {
        question: 'How long does installation take?',
        answer: 'A standard replacement usually takes one full day.',
      },
    ],
  },
  {
    name: 'Painting',
    slug: 'painting',
    iconName: 'PaintbrushIcon',
    description:
      "Refresh your home's interior or exterior with professional painting services.",
    costRange: { low: 1000, high: 5000, average: 2500 },
    benefits: [
      'Most cost-effective way to update a home',
      'Protects exterior surfaces',
      'Improves indoor air quality (low VOC paints)',
      'Hides marks and stains',
      'Quick transformation',
    ],
    faqs: [
      {
        question: "How often should I paint my home's exterior?",
        answer:
          'Typically every 5-10 years, depending on the material and climate.',
      },
      {
        question: 'Do I need to move my furniture?',
        answer:
          'Pros will usually move heavy furniture to the center of the room and cover it.',
      },
      {
        question: 'How many coats of paint are needed?',
        answer: 'Usually two coats provide the best coverage and durability.',
      },
      {
        question: 'What is the best paint finish for bathrooms?',
        answer:
          'Satin or semi-gloss finishes are best as they resist moisture and are easy to clean.',
      },
    ],
  },
  {
    name: 'Plumbing',
    slug: 'plumbing',
    iconName: 'WrenchIcon',
    description:
      'Resolve leaks, clogs, and upgrades with expert plumbing services.',
    costRange: { low: 150, high: 1500, average: 400 },
    benefits: [
      'Prevents water damage',
      'Improves water pressure',
      'Ensures safe drinking water',
      'Upgrades to efficient fixtures',
      'Peace of mind',
    ],
    faqs: [
      {
        question: 'Why is my water bill suddenly so high?',
        answer:
          'This is often a sign of a hidden leak, such as a running toilet or underground pipe leak.',
      },
      {
        question: 'How long do water heaters last?',
        answer:
          'Traditional tank heaters last 8-12 years, while tankless models can last 20 years.',
      },
      {
        question: 'Can I use chemical drain cleaners?',
        answer:
          'Plumbers advise against them as they can damage pipes. Snaking is a safer method.',
      },
      {
        question: 'What should I do in a plumbing emergency?',
        answer:
          'Locate and shut off your main water valve immediately, then call a professional.',
      },
    ],
  },
  {
    name: 'Electrical',
    slug: 'electrical',
    iconName: 'ZapIcon',
    description:
      'Ensure your home is safe and fully powered with professional electrical work.',
    costRange: { low: 200, high: 2000, average: 600 },
    benefits: [
      'Prevents fire hazards',
      'Accommodates modern appliances',
      'Upgrades to smart home tech',
      'Ensures code compliance',
      'Improves lighting',
    ],
    faqs: [
      {
        question: 'When should I upgrade my electrical panel?',
        answer:
          "If your home is over 25 years old, or if you frequently trip breakers, it's time for an upgrade.",
      },
      {
        question: 'Why do my lights flicker?',
        answer:
          'Flickering lights can indicate loose wiring or an overloaded circuit.',
      },
      {
        question: 'Are GFCI outlets required?',
        answer:
          'Yes, they are required by code in areas near water, like kitchens and bathrooms.',
      },
      {
        question: 'Can I do my own electrical work?',
        answer:
          'It is highly discouraged due to the risk of shock, fire, and code violations.',
      },
    ],
  },
  {
    name: 'Fencing',
    slug: 'fencing',
    iconName: 'FenceIcon',
    description:
      'Add privacy, security, and style to your yard with a new fence.',
    costRange: { low: 2000, high: 6000, average: 3500 },
    benefits: [
      'Increases privacy',
      'Keeps pets and children safe',
      'Defines property lines',
      'Enhances curb appeal',
      'Reduces noise',
    ],
    faqs: [
      {
        question: 'What is the best fencing material for privacy?',
        answer:
          'Wood or vinyl privacy fences (6ft tall) are the most popular choices.',
      },
      {
        question: 'Do I need a permit to build a fence?',
        answer:
          'Most municipalities require a permit and have specific height and setback regulations.',
      },
      {
        question: 'How long does a wood fence last?',
        answer: 'With proper maintenance, a wood fence can last 15-20 years.',
      },
      {
        question: 'How long does installation take?',
        answer: 'A typical residential fence takes 2-4 days to install.',
      },
    ],
  },
  {
    name: 'Insulation',
    slug: 'insulation',
    iconName: 'SnowflakeIcon',
    description:
      'Keep your home warm in winter and cool in summer by upgrading insulation.',
    costRange: { low: 1000, high: 3000, average: 1800 },
    benefits: [
      'Significantly lowers energy bills',
      'Improves indoor comfort',
      'Reduces noise transfer',
      'Less strain on HVAC system',
      'Environmentally friendly',
    ],
    faqs: [
      {
        question: 'How do I know if I need more insulation?',
        answer:
          'Drafty rooms, high energy bills, and uneven temperatures between rooms are signs.',
      },
      {
        question: 'What is spray foam insulation?',
        answer:
          "It's an expanding foam that fills gaps and provides an excellent air barrier.",
      },
      {
        question: 'Where is insulation most important?',
        answer:
          'The attic is the most critical area to insulate to prevent heat loss.',
      },
      {
        question: 'Does insulation help with soundproofing?',
        answer:
          'Yes, certain types of insulation, like fiberglass batts or cellulose, absorb sound well.',
      },
    ],
  },
  {
    name: 'Doors',
    slug: 'doors',
    iconName: 'DoorOpenIcon',
    description:
      'Make a great first impression and secure your home with new exterior doors.',
    costRange: { low: 800, high: 3000, average: 1500 },
    benefits: [
      'Enhances curb appeal',
      'Improves security',
      'Increases energy efficiency',
      'Reduces drafts',
      'Smooth operation',
    ],
    faqs: [
      {
        question: 'What is the most secure front door material?',
        answer:
          'Steel and solid fiberglass doors offer the highest level of security.',
      },
      {
        question: 'Do new doors help with energy efficiency?',
        answer:
          'Yes, modern doors have better weatherstripping and insulated cores.',
      },
      {
        question: 'How long does it take to replace a door?',
        answer:
          'A professional can typically replace an exterior door in a few hours.',
      },
      {
        question: 'Should I replace the frame too?',
        answer:
          'Yes, a pre-hung door (which includes the frame) ensures a weather-tight seal.',
      },
    ],
  },
  {
    name: 'Garage Doors',
    slug: 'garage-doors',
    iconName: 'WarehouseIcon',
    description:
      "Upgrade your home's exterior and secure your garage with a new door.",
    costRange: { low: 1000, high: 3000, average: 1500 },
    benefits: [
      'Huge boost to curb appeal',
      'Better security for your home',
      'Improved insulation',
      'Quieter operation',
      'High return on investment',
    ],
    faqs: [
      {
        question: 'How long do garage doors last?',
        answer:
          'A quality garage door can last 15-30 years, though the opener may need replacing sooner.',
      },
      {
        question: 'Should I get an insulated garage door?',
        answer:
          'Yes, especially if your garage is attached to your home or used as a workspace.',
      },
      {
        question: 'Can I replace just a section of the door?',
        answer:
          'Yes, if only one panel is damaged, it can often be replaced without buying a whole new door.',
      },
      {
        question: 'How long does installation take?',
        answer:
          'A professional can usually install a new garage door in 3-5 hours.',
      },
    ],
  },
  {
    name: 'Home Security',
    slug: 'home-security',
    iconName: 'ShieldIcon',
    description:
      'Protect your family and property with a modern home security system.',
    costRange: { low: 300, high: 1500, average: 800 },
    benefits: [
      'Deters burglars',
      '24/7 professional monitoring',
      'Remote access via smartphone',
      'May lower home insurance',
      'Peace of mind',
    ],
    faqs: [
      {
        question: 'Are wireless security systems reliable?',
        answer:
          'Yes, modern wireless systems use encrypted signals and cellular backups.',
      },
      {
        question: 'Do I need a landline for monitoring?',
        answer: 'No, most modern systems use cellular or Wi-Fi connections.',
      },
      {
        question: 'Can I install it myself?',
        answer:
          'Many systems are DIY-friendly, but professional installation ensures optimal placement and setup.',
      },
      {
        question: 'What happens if the power goes out?',
        answer:
          'Security panels have battery backups that keep the system running for up to 24 hours.',
      },
    ],
  },
  {
    name: 'Pest Control',
    slug: 'pest-control',
    iconName: 'BugIcon',
    description: 'Eliminate unwanted guests and protect your home from damage.',
    costRange: { low: 150, high: 500, average: 250 },
    benefits: [
      'Prevents property damage',
      'Protects against health risks',
      'Peace of mind',
      'Customized treatment plans',
      'Long-term prevention',
    ],
    faqs: [
      {
        question: 'Are the chemicals safe for pets and kids?',
        answer:
          'Professionals use targeted, EPA-approved treatments that are safe once dry.',
      },
      {
        question: 'How often should I have pest control treatments?',
        answer: 'Quarterly treatments are standard for general prevention.',
      },
      {
        question: 'Do I need to leave the house during treatment?',
        answer:
          'Usually not for general treatments, but severe infestations (like fumigation) may require it.',
      },
      {
        question: 'How long does it take to see results?',
        answer:
          'You will typically see a significant reduction in pests within 24-48 hours.',
      },
    ],
  },
  {
    name: 'Landscaping',
    slug: 'landscaping',
    iconName: 'TreesIcon',
    description: 'Create a beautiful, functional outdoor living space.',
    costRange: { low: 1500, high: 10000, average: 4000 },
    benefits: [
      'Increases property value',
      'Creates outdoor living areas',
      'Improves drainage',
      'Reduces soil erosion',
      'Enhances curb appeal',
    ],
    faqs: [
      {
        question: 'What is hardscaping?',
        answer:
          'Hardscaping refers to the non-living elements of landscaping, like patios, walkways, and retaining walls.',
      },
      {
        question: 'When is the best time to plant?',
        answer:
          'Spring and early fall are generally the best times for planting trees and shrubs.',
      },
      {
        question: 'Do I need an irrigation system?',
        answer:
          'An irrigation system saves time and ensures your plants receive consistent, efficient watering.',
      },
      {
        question: 'How much does landscaping increase home value?',
        answer: "Good landscaping can increase a home's value by up to 15%.",
      },
    ],
  },
  {
    name: 'Cleaning',
    slug: 'cleaning',
    iconName: 'SparklesIcon',
    description:
      'Keep your home spotless with professional deep cleaning services.',
    costRange: { low: 150, high: 400, average: 200 },
    benefits: [
      'Saves you time',
      'Reduces allergens and dust',
      'Professional grade products',
      'Consistent results',
      'Less stress',
    ],
    faqs: [
      {
        question: 'Do I need to provide cleaning supplies?',
        answer:
          'No, professional cleaners bring their own equipment and supplies.',
      },
      {
        question: 'What is included in a deep clean?',
        answer:
          'Deep cleaning includes baseboards, inside appliances, blinds, and hard-to-reach areas.',
      },
      {
        question: 'Do I need to be home while they clean?',
        answer: 'No, most clients provide a key or code for entry.',
      },
      {
        question: 'Are cleaning services insured?',
        answer: 'Reputable cleaning companies are fully bonded and insured.',
      },
    ],
  },
  {
    name: 'General Repair',
    slug: 'general',
    iconName: 'WrenchIcon',
    description: 'Tackle your to-do list with a skilled local handyman.',
    costRange: { low: 100, high: 600, average: 300 },
    benefits: [
      'Knock out multiple small tasks at once',
      'Professional results',
      'Saves you time and frustration',
      'Prevents small issues from becoming big problems',
      'Cost-effective',
    ],
    faqs: [
      {
        question: 'How do handymen charge?',
        answer: 'Most charge by the hour, plus the cost of materials.',
      },
      {
        question: 'What kind of jobs can a handyman do?',
        answer:
          'Drywall repair, furniture assembly, minor plumbing/electrical, and fixture installation.',
      },
      {
        question: 'Do I need a licensed contractor or a handyman?',
        answer:
          'For major structural, plumbing, or electrical work, hire a licensed contractor. For minor repairs, a handyman is perfect.',
      },
      {
        question: 'Should I buy the materials myself?',
        answer:
          'You can, but handymen often get trade discounts and know exactly what parts are needed.',
      },
    ],
  },
]
